import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import Grid from '../../components/grid/loadable'
import Revenue from '../../components/Revenue'
import styled from 'styled-components'

const Title = styled.h3`
  margin: 10px 0px 20px 10px;
`

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px;
`

const DashboardRevenuePage = ({ setPageTitle }) => {
  useEffect(() => {
    setPageTitle('Dashboard')
  }, [setPageTitle])

  return (
    <div className="container-fluid" style={{ padding: 0 }}>
      <MainContainer>
        <Grid gap="15px" width="900px">
          <Revenue />
        </Grid>
      </MainContainer>
    </div>
  )
}

const mapDispatch = (dispatch) => ({
  setPageTitle: dispatch.Title.setPageTitle,
})

export default connect(null, mapDispatch)(DashboardRevenuePage)
